import { Injectable } from '@angular/core';
import { RestoreCartConnector } from '../data-bindings/restore-cart/restore-cart.connector';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestoreCartService {
  constructor(protected restoreCartConnector: RestoreCartConnector) {}

  restoreCart(cartGuid: string): Observable<string> {
    return this.restoreCartConnector.restoreCart(cartGuid);
  }
}
